<template>
  <v-card class="mr-3 ml-3 mb-3 pa-3">
    <v-card-title class="headline">Добавление Дилера</v-card-title>
    <v-card-text>
      <v-form v-model="isValid" ref="form">
        <v-row>
          <v-col cols="12">
            <v-text-field label="Название"
                          v-model="dealer.name"
                          :rules="[notEmptyRule, length100]"
                          counter="100"
            ></v-text-field>
          </v-col>

          <v-col cols="12" sm="6">
            <v-text-field label="Страна"
                          v-model="dealer.country"
                          :rules="[notEmptyRule, length100]"
                          counter="100"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6">
            <v-text-field label="Город"
                          v-model="dealer.city"
                          :rules="[notEmptyRule, length100]"
                          counter="100"
            ></v-text-field>
          </v-col>

          <v-col cols="12" sm="6">
            <v-text-field label="Телефон"
                          v-model="dealer.phone"
                          :rules="[notEmptyRule, length100]"
                          counter="100"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6">
            <v-text-field label="Email"
                          v-model="dealer.email"
                          :rules="[notEmptyRule, emailRule, length100]"
                          counter="100"
            ></v-text-field>
          </v-col>

          <v-col cols="12">
            <v-select
              v-model="dealer.moneyFor"
              label="Деньги кому?"
              :items="ourLeEntities"
              :rules="[notEmptyRule]"
              :loading="loading"
            >  
            </v-select>
          </v-col>

          <v-col cols="12">
            <v-textarea label="Доп. инфо"
                        :rows="3"
                        v-model="dealer.description"
                        :rules="[notEmptyRule]"
            ></v-textarea>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="primary darken-1" text @click="createDealer"
             :disabled="!isValid">Добавить
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import API from "@/axios/api";

export default {
  name: 'DealerCreate',
  data() {
    return {
      loading: true,
      nameFrozen: '',
      dealer: {},
      choices: {},
      ourLeEntities: [],
      isValid: false,
      notEmptyRule: v => !!v || 'Поле не может быть пустым',
      emailRule: v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,})+$/.test(v) || 'Неверный формат email',
      length100: v => (v && v.length <= 100) || 'Максимум 100 символов',
    }
  },
  async mounted() {
    try {
      const response = await API.get('our_legal_entities/list_for_choices')
      console.log(response.data)
      this.ourLeEntities = response.data.choices
    } catch (error) {
      console.erro(error)
      this.$store.commit('showSnackbar', {
        color: 'error',
        text: 'Ошибка при получении списка наших ЮЛ',
      })
    } finally {
      this.loading = false
    }
  },
  methods: {
    createDealer() {
      API.post('dealers/create', this.dealer)
          .then((response) => {
            console.log(response.data);
            this.$store.commit('showSnackbar', {
              color: 'success',
              text: 'Дилер добавлен',
            })
            // this.$refs.form.reset();
            this.$store.dispatch('updateDealers');
            this.$router.push('/dealers');
          })
          .catch((error) => {
            console.log(error);
            this.$store.commit('showSnackbar', {
              color: 'error',
              text: 'Дилер не добавлен',
            })
          });
    },
  },
  activated() {
    this.$store.commit('setCrumbs', [
      {text: 'main', disabled: false, to: '/', exact: true},
      {text: 'dealers', disabled: false, to: '/dealers', exact: true},
      {text: 'add', disabled: true},
    ])
  },
}
</script>